const notify = (el, { Alpine }) => {
  return {
    error: (title, content) => {
      open(title, content, false);
    },
    success: (title, content) => {
      open(title, content, true);
    },
  };
};

const open = (title, content, success) => {
  const notificationStore = Alpine.store('notification');
  notificationStore.add(title, content, success);
  const index = notificationStore.notifications.length;

  setTimeout(() => {
    notificationStore.remove(index - 1);
  }, 3000);
};

export default notify;
